import React from 'react';
import cn from 'classnames';

import { isTranslate } from 'shared/lib/lang';

import Box, {BoxProps} from '../Box';

import styles from './TableBox.module.scss';

const TableBox: React.FC<BoxProps> = ({children, className}) => {
    return (
        <Box className={cn(
            styles.tableBox,
            styles[isTranslate() ? 'enTableBox' : 'ruTableBox'],
            className,
        )}>
            {children}
        </Box>
    );
};

export default TableBox;